import { ItemPacking, ItemType } from '@hero/schema';

const packingList: Readonly<ItemPacking[]> = [
  'pallet',
  'package',
  'unpackable_item', //  not able to pack the item because of it's size such as fridge big coffee machine. This usually comes with quantity 1
  'bag',
  'barrel',
  'other',
];

/**
 * Item types offered in the pickers, ordered by how often they ship rather
 * than alphabetically — the first handful covers most loads.
 *
 * `liquid` is absent on purpose: it is deprecated in `itemTypeSchema` and
 * maps to a Bayan node that no longer exists. Orders already carrying it
 * still read and display fine; nobody can pick it again.
 */
const itemList: Readonly<ItemType[]> = [
  'food',
  'construction_materials',
  'furniture',
  'appliances',
  'electronics',
  'clothing',
  'textiles',
  'beauty',
  'perfume',
  'plastic',
  'paper',
  'cleaning_materials',
  'medical_supplies',
  'medicines',
  'chemicals',
  'spare_parts',
  'agriculture',
  'livestock',
  'petroleum',
  'mining',
  'waste',
  'vehicles',
  'dangerous_materials',
  'other',
];
const supportedPackingOptions: Readonly<ItemPacking[]> = ['pallet', 'package', 'other'];
export const ordersLoadConfig = {
  packingOptions: packingList,
  itemTypeOptions: itemList,
  /** the supported packing options for the load. for now */
  supportedPackingOptions,
} as const;
